angular.module('igs.common.ach.validation', []);

angular.module('igs.common.ach.validation').directive('igsAchPayment', [
    function () {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: 'components/ACHPayment/ACHPaymentDirective.html',
            scope: {
                achPaymentInfo: '='
            },
            link: function ($scope) {
                $scope.accountNumberVerify = $scope.achPaymentInfo.accountNumber;
                $scope.routingNumberVerify = $scope.achPaymentInfo.routingNumber;

                $scope.getError = function () {
                    if ($scope.achForm.name.$invalid) {
                        return 'Please Enter the name on the bank account'

                    } else if ($scope.achForm.accountNumber.$invalid) {
                        return 'Please enter a valid account number';

                    } else if ($scope.achForm.accountNumberVerify.$invalid) {
                        return 'Account numbers do not match';

                    } else if ($scope.achForm.routingNumber.$invalid) {
                        return 'Please enter a valid routing number';

                    } else if ($scope.achForm.routingNumberVerify.$invalid) {
                        return 'Routing numbers do not match';
                    }
                };
            }
        };
    }
]);